export const PUT_PLACES = 'put_places';
